<template>
  <div>
    <div class="encartFb">
      <a
        href="https://www.facebook.com/IT4Anxiety"
        class="text"
        target="_blank"
      >
        suivez nous
      </a>
      <svg
        width="150"
        height="150"
        version="1.1"
        viewBox="0 0 39.688 39.687"
        xmlns="http://www.w3.org/2000/svg"
      >
        <a
          href="https://www.facebook.com/IT4Anxiety"
          target="_blank"
          class="linkfb"
        >
          <g transform="translate(-51.611 -40.373)">
            <path d="m91.36 80.138h-39.292l39.319-39.577z" fill="#224d9b" />
            <g
              transform="matrix(.043082 0 0 .043082 77.525 57.129)"
              fill="#fff"
              stroke-width="6.1413"
            >
              <g id="XMLID_834_" fill="#fff" stroke-width="6.1413">
                <path
                  id="XMLID_835_"
                  d="m81.703 165.11h33.981v139.89c0 2.762 2.238 5 5 5h57.616c2.762 0 5-2.238 5-5v-139.24h39.064c2.54 0 4.677-1.906 4.967-4.429l5.933-51.502c0.163-1.417-0.286-2.836-1.234-3.899-0.949-1.064-2.307-1.673-3.732-1.673h-44.996v-32.284c0-9.732 5.24-14.667 15.576-14.667h29.42c2.762 0 5-2.239 5-5v-47.274c0-2.762-2.238-5-5-5h-40.545c-0.286-0.014-0.921-0.037-1.857-0.037-7.035 0-31.488 1.381-50.804 19.151-21.402 19.692-18.427 43.27-17.716 47.358v37.752h-35.673c-2.762 0-5 2.238-5 5v50.844c0 2.762 2.238 5.001 5 5.001z"
                  fill="#fff"
                  stroke-width="6.1413"
                />
              </g>
            </g>
          </g>
        </a>
      </svg>
    </div>
    <div class="encartFbMobile">
      <svg
        width="50"
        height="50"
        version="1.1"
        viewBox="0 0 13.229 13.229"
        xmlns="http://www.w3.org/2000/svg"
      >
      <a
        href="https://www.facebook.com/IT4Anxiety"
        class="text"
        target="_blank"
      >
        <circle cx="6.5982" cy="6.6316" r="6.5982" style="fill: #0c4da2" />
        <g
          transform="matrix(.023563 0 0 .023563 3.5518 1.6828)"
          style="fill: #fff; stroke-width: 11.228"
        >
          <g id="XMLID_834_" style="fill: #fff; stroke-width: 11.228">
            <path
              id="XMLID_835_"
              d="m20.215 236.91h47.764v196.64c0 3.8823 3.1457 7.028 7.028 7.028h80.985c3.8823 0 7.028-3.1458 7.028-7.028v-195.71h54.909c3.5702 0 6.574-2.6791 6.9816-6.2254l8.3395-72.392c0.22912-1.9918-0.402-3.9863-1.7345-5.4805-1.3339-1.4956-3.2427-2.3516-5.2457-2.3516h-63.247v-45.379c0-13.679 7.3654-20.616 21.894-20.616h41.353c3.8823 0 7.028-3.1472 7.028-7.028v-66.449c0-3.8823-3.1458-7.028-7.028-7.028h-56.99c-0.402-0.019679-1.2946-0.052008-2.6102-0.052008-9.8884 0-44.26 1.9411-71.41 26.919-30.083 27.679-25.901 60.821-24.902 66.567v53.064h-50.142c-3.8823 0-7.028 3.1458-7.028 7.028v71.467c0 3.8823 3.1458 7.0294 7.028 7.0294z"
              style="fill: #fff; stroke-width: 11.228"
            />
          </g>
        </g>
      </a>
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    // hello() {
    //   console.log("hello");
    //   // window.open("https://www.facebook.com/IT4Anxiety", '_blank');
    // },
  },
};
</script>

<style lang="scss" scopped>
.encartFbMobile {
  position: fixed;
  bottom: 3px; // pour que ça arrive en dessous
  left: 10px;
  z-index: 70;
}
.encartfbv2 {
  position: fixed;
  bottom: -7px; // pour que ça arrive en dessous
  right: 0;
  z-index: 50;
  border: 0 100% 0 0 red;
  img {
    display: block;
  }
  .text {
    border: 1px solid red;
    position: absolute;
    bottom: 15px;
    right: 10px;
    font-weight: bold;
    font-size: 18px;
    color: white;
    &:after {
      content: "";
      position: absolute;
      width: 50%;
      left: 0;
      bottom: 0;
    }
  }
  &:hover {
    .text {
      color: red !important;
      &:after {
        width: 100%;
        border: 1px solid #fbbf1c !important;
      }
    }
  }
}
.encartFb {
  display: none;
}
@media screen and (min-width: 800px) {
  .encartFbMobile{
    display: none;
  }
  .encartFb {
    display: block;
    position: fixed;
    bottom: -7px; // pour que ça arrive en dessous
    right: 0;
    z-index: 50;
    border: 0 100% 0 0 red;

    img {
      display: block;
    }
    .linkfb {
      // display: block;
      #XMLID_835_ {
        transition: all 0.3s ease-in-out;
      }
      &:before {
        content: "";
        position: absolute;
        border: 1px solid red;
        width: 100%;
        width: 50px;
        height: 50px;
        background-color: goldenrod;
        // left: 0;
        // bottom: -10px;
        // top:0;
        z-index: 100;
        // transition: all 0.3s ease-in-out;
      }
      &:hover {
        // #XMLID_835_ {
        //   fill: #fbbf1c;
        // }
      }
    }
    .text {
      position: absolute;
      bottom: 15px;
      right: 10px;
      font-weight: bold;
      font-size: 18px;
      color: white;
      transition: all 0.5s ease-in-out;
      &:after {
        content: "";
        position: absolute;
        border: 1px solid white;
        width: 50%;
        left: 0;
        bottom: 0;
        transition: all 0.3s ease-in-out;
      }
    }
    // #XMLID_835_{
    //   transition: all .3s ease-in-out;
    // }
    &:hover {
      // border: border 1px solid red;
      // #XMLID_835_{
      //   fill: #fbbf1c;
      // }
      .text {
        // color: #fbbf1c;
        &:after {
          width: 100%;
          border: 1px solid #fbbf1c;
        }
      }
    }
  }
}
</style>